export default __webpack_public_path__ + "static/media/109.64b4ec19.png";